import axios from 'axios';

export default function userInfo(token) {
    const config = {
        headers: { Authorization: token }
    };

    // get user info
    return axios.get('/users/details', config);
}
